var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"func-10-novo"}},[_c('funcionalidade-header',{attrs:{"title":_vm.tituloNavegacao}}),(_vm.idTemplate)?_c('TemplateSolicitacao',{attrs:{"id-template":_vm.idTemplate,"titulo":_vm.tituloNavegacao,"id-funcionalidade":_vm.funcionalidade.idFuncionalidade,"id-tipo-ocorrencia":_vm.idTipoOcorrencia,"listagem-popup":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }